export default __webpack_public_path__ + "static/media/trips_small.410edc0f.png";